import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
} from "@mui/material";
import { getTeacherWorkloads } from "../teacherStats/teacherWorkloads";
import { useSondertagContext } from "../context/sondertagContext";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

function normalizeAbbr(abbr) {
  return abbr?.trim().toLowerCase();
}

export default function SondertagStatsInfoDialog({
  open,
  onClose,
  targetValue,
  totalWork,
  totalSlots = 0, // ✅ NEW
  noTeacherSlots = 0, // ✅ NEW
  totalWorkload = 0,
}) {
  const { currentUser } = useAppContext();
  const { teacherWorkloads } = useSondertagContext();

  const workloads = teacherWorkloads ? teacherWorkloads : {};

  const key = normalizeAbbr(currentUser?.abbreviation);
  const workload = workloads?.[key]?.workload ?? 0;

  // ✅ derived values
  const extraWork = Math.max(0, totalWork - totalSlots);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Wie wird dein Jahreszielwert berechnet?</DialogTitle>

      <DialogContent dividers>
        {/* ✅ INTRO */}
        <Typography variant="body2" paragraph>
          Der Jahreszielwert ergibt sich proportional aus dem persönlichen
          Unterrichtspensum im Verhältnis zum Gesamt-Pensenpool.
        </Typography>

        <Typography variant="body2">
          • Alle Unterrichtsgefässe müssen belegt werden
        </Typography>
        <Typography variant="body2" paragraph>
          • Mehrfachbesetzungen (z.B. Team-Teaching) werden im Gesamtaufwand
          berücksichtigt.
        </Typography>

        {/* ✅ ✅ REAL NUMBERS FIRST */}
        <Typography variant="subtitle2" sx={{ mt: 2 }}>
          Aktuelle Situation:
        </Typography>

        <Typography variant="caption" sx={{ display: "block", opacity: 0.8 }}>
          Grundaufwand: {totalSlots} Unterrichtsgefässe
        </Typography>
        <Typography variant="caption" sx={{ display: "block", opacity: 0.8 }}>
          (weil Gefässe ohne Personalbedarf: - {noTeacherSlots})
        </Typography>
        <Typography variant="caption" sx={{ display: "block", opacity: 0.8 }}>
          Zusätzlicher Aufwand durch Mehrfachbesetzungen: + {extraWork}
        </Typography>

        <Typography
          variant="caption"
          sx={{ display: "block", fontWeight: 600, mt: 0.5 }}
        >
          Gesamtaufwand: {totalWork} Einsätze
        </Typography>

        {/* ✅ PERSONAL PART */}
        <Typography
          variant="caption"
          sx={{ opacity: 0.7, mt: 1.5, display: "block" }}
        >
          Dein aktuelles Jahresziel (in Halbtagen): {targetValue.toFixed(1)}{" "}
          Angebote
        </Typography>

        <Typography variant="caption" sx={{ opacity: 0.7, display: "block" }}>
          Dein Pensum zur Berechnungsgrundlage: {(workload * 100).toFixed(0)}%
        </Typography>

        <Typography variant="caption" sx={{ opacity: 0.7, display: "block" }}>
          Gesamt-Pensenpool: {totalWorkload?.toFixed(1)} Vollzeitstellen
        </Typography>

        {/* ✅ FORMULA LAST */}
        <Typography variant="caption" paragraph sx={{ opacity: 0.7, mt: 2 }}>
          Berechnung:
        </Typography>

        <Box
          component="pre"
          sx={{
            mt: 1,
            p: 1.5,
            backgroundColor: "rgba(0,0,0,0.06)",
            borderRadius: 1,
            fontSize: "0.75rem",
            overflow: "auto",
          }}
        >
          {`Grundaufwand = Anzahl Unterrichtsgefässe minus Gefässe ohne Personalbedarf (z.B. MAAR)

Gesamtaufwand = Grundaufwand + zusätzliche Einsätze von Lehrpersonen im selben Unterrichtsgefäss

Jahreszielwert (in Halbtagen) = (Pers. Unterrichtspensum / Gesamt-Pensenpool) * Gesamtaufwand`}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
